'use client';
import { memo, useCallback } from 'react';
import {
  useComponentsContext,
  useEventContext,
  useHoveredContext,
  useSelectedContext,
} from '../lib/context';
import { useIsHoveredDay } from '../lib/hooks/data';

export default memo(({ data, utcOffset }: any) => {
  const { DataTable } = useComponentsContext();
  const { handleMouseEnter, handleMouseLeave, handleClick } = useEventContext();
  const isHovered = useHoveredContext();
  const isSelected = useSelectedContext();

  const isHoveredDay = useIsHoveredDay(data, utcOffset);

  const isHighlighted = useCallback(
    (id: any) => isHovered(id) || isSelected(id) || isHoveredDay(id),
    [isHovered, isSelected, isHoveredDay],
  );

  return (
    <DataTable
      data={data}
      isHighlighted={isHighlighted}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    />
  );
});
